import { A } from '@adornis/base/env-info.js';
import { registerMutation } from '@adornis/baseql/metadata/register.js';
import { getContactByIDCOQL } from '@adornis/digitale-helden-shared/api/Contact/getContactByIDCOQL.js';
import { Contact } from '@adornis/digitale-helden-shared/db/Contact.js';
import { ContactEmailStatus } from '@adornis/digitale-helden-shared/db/enums.js';
import { UpsertContactOptions } from '@adornis/digitale-helden-shared/db/UpsertContactOptions.js';
import {
  ActionTokenData,
  TokenAction,
} from '@adornis/digitale-helden-shared/features/action-tokens/db/ActionTokenData.js';
import { createActionToken } from '@adornis/digitale-helden-shared/features/action-tokens/db/createActionToken.js';
import { sendDigitaleHeldenMail } from '@adornis/digitale-helden-shared/features/mailing/server/mailer.js';
import { doubleOptInTemplate } from '@adornis/digitale-helden-shared/features/mailing/server/templates/double-opt-in-template.js';
import { getLASUserByEmail } from '@adornis/digitale-helden-shared/features/users/api/getUserByEmail.js';
import { Recipient } from '@adornis/mails/db/recipients.js';
import { Message } from '@adornis/mails/server/communication.js';
import { CampusRoute } from '../../../_routing/db/enums.js';
import { upsertContact } from './upsertContact.js';

export const sendContactDOIMail = registerMutation({
  type: () => Boolean,
  operationName: 'sendContactDOIMail',
  resolve: (contactID: string, createAccount: boolean, redirectURL?: string) => {
    return async () => {
      const contact = await getContactByIDCOQL(contactID)(Contact.allFields);
      if (!contact) return false;

      const lasAccount = await getLASUserByEmail(contact.email)({ _id: 1 });
      if (contact.emailStatus === ContactEmailStatus.DOI && (lasAccount || !createAccount)) {
        return false;
      }

      const token = new ActionTokenData({ action: TokenAction.DOI, contact, createAccount });
      const tokenId = await createActionToken(token)();
      const accessLink = A.absoluteUrl(CampusRoute.ACTION, new URLSearchParams({ tokenId: tokenId }));

      try {
        await sendDigitaleHeldenMail({
          message: async (webversionLink: string) =>
            await Message.compose(
              await doubleOptInTemplate({
                accessLink,
                firstName: contact.firstName ?? '',
                createAccount,
                webmailLink: webversionLink,
                redirectURL,
              }),
            ),
          recipients: new Recipient([contact.email]),
        });
      } catch (err) {
        console.error(err);
        return false;
      }

      if (
        ![ContactEmailStatus.SOI_BOOKINGS, ContactEmailStatus.SOI, ContactEmailStatus.DOI].includes(
          contact.emailStatus as ContactEmailStatus,
        )
      ) {
        contact.emailStatus = ContactEmailStatus.OPT_IN_PENDING;
        await upsertContact(contact, new UpsertContactOptions({ checkStatus: true }))({ id: 1 });
      }

      return true;
    };
  },
  params: [
    { name: 'contactID', type: () => String },
    { name: 'createAccount', type: () => Boolean },
    { name: 'redirectURL', type: () => String },
  ],
});
